// Decodes issuer-level controls that materially affect how a token behaves on ledger.
// Everything here is read from validated ledger state, never inferred from issuer marketing.

const ACCOUNT_FLAGS = [
  { mask: 0x80000000, key: 'clawback', label: 'Clawback enabled', tone: 'control' },
  { mask: 0x00040000, key: 'requireAuth', label: 'Authorization required', tone: 'control' },
  { mask: 0x00400000, key: 'globalFreeze', label: 'Global freeze active', tone: 'alert' },
  { mask: 0x00200000, key: 'noFreeze', label: 'Freeze permanently disabled', tone: 'open' },
  { mask: 0x00800000, key: 'defaultRipple', label: 'Rippling enabled', tone: 'neutral' },
  { mask: 0x01000000, key: 'depositAuth', label: 'Deposit authorization', tone: 'control' },
  { mask: 0x00100000, key: 'disableMaster', label: 'Master key disabled', tone: 'neutral' },
];

const MPT_FLAGS = [
  { mask: 0x0040, key: 'clawback', label: 'Clawback enabled', tone: 'control' },
  { mask: 0x0004, key: 'requireAuth', label: 'Authorization required', tone: 'control' },
  { mask: 0x0001, key: 'locked', label: 'Issuance locked', tone: 'alert' },
  { mask: 0x0002, key: 'canLock', label: 'Issuer can lock', tone: 'control' },
  { mask: 0x0020, key: 'canTransfer', label: 'Holder transfers allowed', tone: 'open' },
  { mask: 0x0010, key: 'canTrade', label: 'DEX trading allowed', tone: 'open' },
  { mask: 0x0008, key: 'canEscrow', label: 'Escrow allowed', tone: 'open' },
];

function decodeFlags(table, value) {
  const flags = Number(value) || 0;
  return table.filter((flag) => (flags & flag.mask) !== 0).map(({ key, label, tone }) => ({ key, label, tone }));
}

export function transferFeePercent(transferRate) {
  const rate = Number(transferRate);
  if (!Number.isFinite(rate) || rate <= 1_000_000_000) return 0;
  return Math.round(((rate - 1_000_000_000) / 1_000_000_000) * 100_000) / 1000;
}

export function mptTransferFeePercent(transferFee) {
  const fee = Number(transferFee);
  if (!Number.isFinite(fee) || fee <= 0) return 0;
  return fee / 1000;
}

export function decodeAccountControls(accountData = {}) {
  const fee = transferFeePercent(accountData.TransferRate);
  const controls = decodeFlags(ACCOUNT_FLAGS, accountData.Flags);
  if (fee > 0) controls.push({ key: 'transferFee', label: `Transfer fee ${fee}%`, tone: 'control' });
  return {
    kind: 'classic',
    flags: Number(accountData.Flags) || 0,
    transferFeePercent: fee,
    ownerCount: Number(accountData.OwnerCount) || 0,
    controls,
  };
}

export function decodeMptControls(node = {}) {
  const fee = mptTransferFeePercent(node.TransferFee);
  const controls = decodeFlags(MPT_FLAGS, node.Flags);
  if (fee > 0) controls.push({ key: 'transferFee', label: `Transfer fee ${fee}%`, tone: 'control' });
  if (!controls.some((control) => control.key === 'canTransfer')) {
    controls.push({ key: 'issuerOnly', label: 'Issuer-only transfers', tone: 'control' });
  }
  return {
    kind: 'mpt',
    flags: Number(node.Flags) || 0,
    transferFeePercent: fee,
    controls,
  };
}
